export const ADMIN_WORKSPACE_ROLES = Object.freeze([
  'admin',
  'tenant_admin',
  'moderator',
  'support',
  'staff',
  'support_agent',
  'finance',
  'finance_staff',
  'survey_staff',
  'agent',
  'affiliate_manager',
  'referral_agent',
]);

export const OPEN_ADMIN_WORKSPACE_MENU_EVENT = 'slotsoceans:open-admin-menu';

export function hasAdminWorkspaceRole(role) {
  return ADMIN_WORKSPACE_ROLES.includes(role);
}

export function hasLiveChatMenu(menuItems = []) {
  return menuItems.some((item) => item?.id === 'chat');
}
